/* eslint-disable */

import { grey } from '@material-ui/core/colors';

/**
 * Create styles for `<DateNav />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<DateNav />` styles
 */
const dateNavStyles = ({ theme }) => ({
  calendarIcon: {
    color: `#000`,
  },
  select: {
    [`&:focus`]: {
      background: `unset`,
    },
    paddingRight: `${theme.spacing(1)}px !important`,
  },
  today: {
    background: grey[200],
  },
});

export default dateNavStyles;
